import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { JwtDecoder } from './jwt-decoder.service';
import { LoginService } from './../login.service';

@Injectable()
export class AuthGuard implements CanActivate {
  public authToken;
  private isAuthenticated: boolean; // Set this value dynamically

  constructor(
    private router: Router,
    private tokenDecoder: JwtDecoder,
    private loginService: LoginService,
  ) {
    var roleArray = [];
    if (this.tokenDecoder.getUserInformation()) {
      // if(this.tokenDecoder.getUserInformation().user.role){
      //   roleArray = this.tokenDecoder.getUserInformation().user.role.split(',');
      //   if(roleArray[0].toLowerCase() === 'agent' || (roleArray[1] && roleArray[1].toLowerCase() === 'agent')){
      //     this.isAuthenticated = true;
      //   } else {
      //     this.isAuthenticated = false;
      //   }
      // }
      this.isAuthenticated = true;
    }
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.isAuthenticated) {
      return true;
    }
    this.loginService.saveRedirectUrl(state.url);
    this.router.navigate(['/login']);
    return false;
  }
}
